// @flow

import React, { Component } from 'react'
import { Breakpoint } from 'react-socks'
import { Container, Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import Lottie from 'react-lottie'
import Swal from 'sweetalert2';
import differenceInHours from 'date-fns/differenceInHours';
import * as animationData from '../assets/loading.json'
import * as animationData404 from '../assets/404.json'
import '../styles/RestaurantTable.scss'
import { updateRestoInfo, updateType, resetCart, applyDiscount, applyCoupon, pickedOrderType, updateTable, updateQrId } from '../actions/cartAction';
import { updateRestoSettings, updateDeliverySchedule, updateOrderSchedule, updateDeliverySettings, updateTakeawaySettings, updateMenuSettings, setLanguage } from '../actions/settingsAction';

import CartKiosk from './CartKiosk'
import ProductDetail from './ProductDetail'
import LanguageSelector from './LanguageSelector'
import $ from "jquery"

import { parseSchedule, computeDiscount, convertFirebaseUrlToCustomDomain, formatCurrency } from './Utils'
import { CartType, ProductType } from '../flowObjectType'
import { firestore, analytics } from '../services/firebase'
import dayjs from 'dayjs'
import { getAvailabilityPeriod, isProductAvailable } from '../utils/availabilityUtils'
import { isPublicHolidayToday } from '../utils/publicHolidays'
import { getSecondaryFirestore } from '../services/firebaseSecondary'
import { getTrans, getActiveLanguages, DEFAULT_LANG } from '../utils/translations'

// color
// text black
// background #F1F1F1
// blue #00CCBB
// yellow #FDC151
// red #FF4B4B

type Props = {
  match: Object,
  cart: CartType,
  settings: Object,
  updateType: Function,
  updateRestoInfo: Function,
  updateRestoSettings: Function,
  updateDeliverySchedule: Function,
  updateOrderSchedule: Function,
  resetCart: Function,
  updateTakeawaySettings: Function,
  updateDeliverySettings: Function,
  setLanguage: Function,
  t: Function,
}

type State = {
  canOrder: boolean,
  settings: Object,
  informations: Object,
  showProductDetail: boolean,
  restaurant: Object,
  sections: Array<Object>,
  selectedProduct: ?ProductType,
  invalidQrCode: boolean,
  selectedCategoryIdx: number,
  selectedIdx: ?number,
  orderType: ?number,
  table: ?string,
  showCart: boolean
}

function goToAnchor(event: Object, id: string) {
  const productPositionY = $(`#section-${id}`).offset().top - 65
  // $(event.target).css('backgroundColor', 'white')
  $("html, body").animate({ scrollTop: productPositionY }, 500);
  event.preventDefault();
}

let savedSticky = 0
function handleStickyHeader(header) {
  let sticky = header[0].offsetTop
  if (header.hasClass("sticky")) {
    sticky = savedSticky
  }

  if (window.pageYOffset > sticky) {
    savedSticky = sticky
    header.addClass("sticky");
  } else {
    header.removeClass("sticky");
  }
}
function handleActiveSection(header) {

  const topMenuHeight = header.outerHeight() + 10
  const menuItems = header.find(".options-btn")
  const scrollItems = menuItems.map(function () {
    var item = $($(this).attr("href"));
    if (item.length) { return item; }
    return null
  });

  var fromTop = window.scrollY + topMenuHeight;
  var lastId;
  // Get id of current scroll item

  var cur = scrollItems.map(function () {
    if ($(this).offset().top < fromTop)
      return this;
    return null
  });
  // Get the id of the current element
  cur = cur[cur.length - 1];
  var id = cur && cur.length ? cur[0].id : "";

  if (lastId !== id) {
    lastId = id;
    // Set/remove active class
    if (id === "") return
    menuItems.removeClass("selected")
    const selectedItem = menuItems.filter("[href='#" + id + "']")
    selectedItem.addClass("selected");
    if (selectedItem[0]) {
      selectedItem[0].scrollIntoView({
        behavior: 'instant',
      });
    }
  }

}

const CategoryRow = (props) => (
  <>
    <a href={`#section-${props.category.id}`} className={`options-btn ${props.selected ? 'selected' : ''}`} onClick={(event) => { goToAnchor(event, props.category.id) }}>
      {getTrans(props.category, 'name', props.lang)}
    </a>
  </>
)

const Section = (props) => (
  <div>
    <h3 className="section" id={`section-${props.id}`}>
      <div className="section-title">{props.title.toUpperCase()}</div>
    </h3>
    {props.description && (
      <div className="section-description">
        {props.description}
      </div>
    )}
  </div>
)

const ProductRow = (props) => {
  const { product, orderType, settings, t } = props
  const cartProducts = props.cartProducts ? props.cartProducts.filter(e => e.id === product.id) : [];
  const totalQuantity = cartProducts.length > 0 ? cartProducts.reduce((total, p) => total + p.quantity, 0) : 0;
  const price = formatCurrency(product.unitPrice, settings.currencySymbol)
  const unitPrice = parseFloat(product.unitPrice);

  let discountPrice = 0;
  let hasDiscount = false;
  let discountLabel = '';

  if (orderType === 1 && product.takeawayDiscount && product.takeawayDiscount.discount) {
    discountPrice = unitPrice * (1 - product.takeawayDiscount.discount / 100)
    hasDiscount = true;
    discountLabel = product.takeawayDiscount.discount
  }
  else if (orderType === 4 && product.deliveryDiscount && product.deliveryDiscount.discount) {
    discountPrice = unitPrice * (1 - product.deliveryDiscount.discount / 100)
    hasDiscount = true;
    discountLabel = product.deliveryDiscount.discount
  }
  else if ((orderType === 2 || orderType === 3) && product.tableDiscount && product.tableDiscount.discount) {
    discountPrice = unitPrice * (1 - product.tableDiscount.discount / 100)
    hasDiscount = true;
    discountLabel = product.tableDiscount.discount
  }

  return (
    <div 
      className={`relative w-48 h-96 bg-white rounded-lg border border-gray-200 overflow-hidden cursor-pointer transition-all duration-200 hover:border-blue-500 hover:shadow-md ${cartProducts.length > 0 ? 'ring-2 ring-blue-500 border-blue-500' : ''}`} 
      onClick={props.toggleModal(product)}
    >
      {/* Product Image */}
      {product.image.path !== '' && (
        <div className="w-full h-32">
          <img
            className="w-full h-full object-cover"
            src={convertFirebaseUrlToCustomDomain(product.image.path, props.cdnDomain)}
            alt={getTrans(product, 'name', props.lang)}
          />
        </div>
      )}
      
      {/* Product Content */}
      <div className="p-3 flex flex-col gap-1 h-64">
        {/* Product Name */}
        <h3 className="font-semibold text-base text-gray-900 leading-tight line-clamp-2">
          {getTrans(product, 'name', props.lang)}
        </h3>
        
        {/* Product Description */}
        {product.description !== "" && (
          <p className="text-gray-600 text-xs leading-relaxed line-clamp-3 flex-1">
            {getTrans(product, 'description', props.lang)}
          </p>
        )}

        {/* Product Price */}
        <div className="mt-auto">
          {hasDiscount && (
            <div className={`${!product.canOrder ? 'text-red-500' : 'text-gray-900'}`}>
              <span className="line-through text-gray-500 text-sm">{formatCurrency(unitPrice, settings.currencySymbol)}</span>
              <span className="ml-1 font-semibold text-sm">{t('restaurant.discountPrice', { discount: discountLabel, price: formatCurrency(discountPrice, settings.currencySymbol) })}</span>
              {!product.canOrder && (
                <span className="block text-red-500 text-xs">{t('common.unavailable')}</span>
              )}
            </div>
          )}
          {!hasDiscount && product.unitPrice > 0 && (
            <div className={`font-semibold text-base ${!product.canOrder ? 'text-red-500' : 'text-gray-900'}`}>
              {price}
              {!product.canOrder && (
                <span className="block text-red-500 text-xs">{t('common.unavailable')}</span>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Quantity Badge */}
      {cartProducts.length > 0 && (
        <div className="absolute top-2 right-2 bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-semibold">
          {totalQuantity}
        </div>
      )}
    </div>
  )
}

const getResto = async (restoName) => {
  const docs = await firestore()
    .collection('Restaurant')
    .where('urlName', '==', restoName)
    .get();

  if (!docs.empty) {
    const data = {
      id: docs.docs[0].id,
      ...docs.docs[0].data(),
    }

    return data;
  }
  else {
    return null;
  }
}

class RestaurantKiosk extends Component<Props, State> {
  unsubscribe: Object
  refRestaurant: Object
  refProduct: Object
  refCategory: Object
  refDiscount: Object
  refOption: Object
  readOnly: boolean
  products: Array<Object>
  categories: Array<Object>
  discounts: Array<Object>
  options: Array<Object>
  selectCategory: Function

  constructor(props: Object) {
    super(props);

    this.unsubscribe = null
    this.refRestaurant = null
    this.refProduct = null
    this.refCategory = null
    this.refDiscount = null
    this.refOption = null

    this.readOnly = false
    this.allProducts = []
    this.availabilityTimer = null
    this.availabilityHours = null
    this._lastAvailabilityKey = null
    this.products = []
    this.categories = []
    this.discounts = []
    this.options = []

    this.state = {
      canOrder: false,
      settings: null,
      informations: null,
      showProductDetail: false,
      restaurant: null,
      sections: [],
      selectedProduct: null,
      invalidQrCode: false,
      selectedCategoryIdx: 0,
      selectedIdx: undefined,
      orderType: undefined,
      table: null,
      showCart: false,
    }
  }

  componentDidMount() {
    const cartCreatedAt = new Date(this.props.cart.createdAt);
    if (this.props.cart.flushCart === true || isNaN(cartCreatedAt) || differenceInHours(new Date(), cartCreatedAt) >= 10) {
      this.props.resetCart();
    }
    const id = this.props.match.params.id

    if (id) {
      this.handleClickAndCollect()
    }
  }

  handleClickAndCollect = async () => {
    const restoName = this.props.match.params.id.toLowerCase()

    const resto = await getResto(restoName)
    if (resto === null) {
      this.setState({ invalidQrCode: true })
      Swal.fire(this.props.t('restaurant.invalidQrTitle'), this.props.t('restaurant.invalidQrText'), "error");
      return
    }
    await this.initRestaurant(resto.id, resto)
    this.setState({ orderType: 2 })
    this.props.updateType(2);
  }


  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe()
    if (this.availabilityTimer) clearInterval(this.availabilityTimer)
  }

  loadScript = () => {
    const header = $("#sticky-header");
    if (header.length) {
      window.onscroll = () => {
        handleActiveSection(header)
        handleStickyHeader(header)
      }
    }
  }

  initRestaurant = async (restoId, resto) => {
    // Determine if menu data should come from a secondary Firebase project
    let menuFirestore = firestore()
    let menuRestoId = restoId
    this.cdnDomain = null // null means use default CDN

    if (resto?.settings?.externalSource) {
      try {
        const secondaryFs = getSecondaryFirestore()
        const extDocs = await secondaryFs
          .collection('Restaurant')
          .where('urlName', '==', resto.settings.externalSource)
          .get()

        if (!extDocs.empty) {
          menuFirestore = secondaryFs
          menuRestoId = extDocs.docs[0].id
          this.cdnDomain = 'https://cdn2.we-eats.com'
        } else {
          console.warn(`externalSource "${resto.settings.externalSource}" not found in secondary project, falling back to primary`)
        }
      } catch (err) {
        console.warn('Failed to initialize secondary Firebase, falling back to primary:', err)
      }
    }

    // Settings, discounts always from primary
    this.refRestaurant = firestore().collection('Restaurant').doc(restoId)
    this.refDiscount = firestore().collection(`Restaurant/${restoId}/Discount`)

    // Menu data (products, categories, options) from resolved source
    this.refProduct = menuFirestore.collection(`Restaurant/${menuRestoId}/Product`)
    this.refOption = menuFirestore.collection(`Restaurant/${menuRestoId}/Rubric`)
    this.refCategory = menuFirestore.collection(`Restaurant/${menuRestoId}/Category`).where('status', '==', 1)

    this.unsubscribe = this.refRestaurant.onSnapshot(this.onRestoUpdate)

    // Re-check product availability every 60 seconds for time-based filtering.
    // checkProductWithAvailability short-circuits when no day/period boundary has been crossed.
    this.availabilityTimer = setInterval(this.checkProductWithAvailability, 60000)

    const productP = this.refProduct.get()
    const categoryP = this.refCategory.get()
    const discountP = this.refDiscount.get()
    const optionP = this.refOption.get()

    Promise.all([productP, categoryP, discountP, optionP])
      .then(([product, category, discount, option]) => {
        const products = []
        const categories = []
        const discounts = []
        const options = []

        const allProducts = []
        product.forEach((doc) => {
          const { createdAt, ...data } = doc.data()
          allProducts.push({ id: doc.id, ...data })
        });
        this.allProducts = allProducts
        products.push(...this.filterProducts(allProducts))
        category.forEach((doc) => {
          const { createdAt, ...data } = doc.data()
          if (!data.internal && (data.displayApp || data.displayApp === undefined)) categories.push({ id: doc.id, ...data })
        });
        discount.forEach((doc) => {
          const { createdAt, ...data } = doc.data()
          discounts.push({ id: doc.id, ...data })
        });
        option.forEach((doc) => {
          const { id, products, shared, ...data } = doc.data()
          options.push({ id: doc.id, ...data })
        })
        this.products = products
        this.categories = categories.sort((a, b) => (a.index < b.index ? -1 : 1))
        this.discounts = discounts
        this.options = options
        this.getSections()
        return true
      })
      .catch(err => {
        console.log(err)
        return false
      })
  }

  onRestoUpdate = (querySnapshot: Object) => {
    const restaurant = querySnapshot.data()
    const orderSchedule = parseSchedule(restaurant.settings.orderSchedule);
    const deliverySchedule = parseSchedule(restaurant.settings.deliverySchedule);

    const deliverySettings = restaurant.deliverySettings || {};
    const takeawaySettings = restaurant.takeawaySettings || {};

    this.props.updateRestoInfo(restaurant.informations.id, restaurant.informations.name, restaurant.informations.postalCode, restaurant.state.canOrderTable ?? true, restaurant.informations);
    this.props.updateRestoSettings(restaurant.informations.id, restaurant.settings.color, restaurant.settings.autoAcceptOrder, restaurant.settings.delivery, restaurant.settings.takeaway, restaurant.settings.table, restaurant.settings.stripe || '', restaurant.settings.orderTypePopup || false, restaurant.settings.sharedCart || false, restaurant.settings.currencySymbol || '€', restaurant.settings.showCurrencyOnOrder !== false);
    this.props.updateMenuSettings({ productComments: restaurant.settings.productComments, languages: restaurant.settings.languages });
    // Langue choisie non activée par le restaurant : retour au français
    if (!getActiveLanguages(restaurant.settings).includes(this.props.settings.lang)) {
      this.props.setLanguage(DEFAULT_LANG)
    }
    this.props.updateDeliverySchedule(deliverySchedule);
    this.props.updateOrderSchedule(orderSchedule);
    this.props.updateDeliverySettings(deliverySettings);
    this.props.updateTakeawaySettings(takeawaySettings);
    this.availabilityHours = restaurant.settings?.availabilityHours ?? null
    this._lastAvailabilityKey = null
    this.checkProductWithAvailability()

    if (!restaurant.settings.delivery && !restaurant.settings.takeaway && !restaurant.settings.table) {
      this.readOnly = true
    }


    analytics().logEvent('home_page', { restoId: restaurant.informations.id, restoName: restaurant.informations.name });


    setTimeout(() => {
      this.setState({
        settings: restaurant.settings,
        informations: restaurant.informations,
        restaurant: restaurant,
        canOrder: restaurant.state.canOrderTable ?? true
      })
      this.loadScript()
    }, 1000)
  }

  /**
   * Visibilité d'un produit : disponibilité horaire (créneaux midi/soir par jour,
   * jours fériés) — même filtre que we-kiosk-order.
   */
  filterProducts = (list: Array<Object>) => {
    const isPublicHoliday = isPublicHolidayToday()
    const period = getAvailabilityPeriod(this.availabilityHours, dayjs().day(), isPublicHoliday)
    return list.filter((p) => isProductAvailable(p, period, isPublicHoliday))
  }

  // Re-filtre les produits quand on change de jour ou de service (midi/soir) ;
  // court-circuite tant qu'aucune frontière n'a été franchie.
  checkProductWithAvailability = () => {
    if (this.allProducts.length === 0) return
    const isPublicHoliday = isPublicHolidayToday()
    const { isDayTime, serviceDay } = getAvailabilityPeriod(this.availabilityHours, dayjs().day(), isPublicHoliday)
    const key = `${isPublicHoliday ? 1 : 0}|${serviceDay}|${isDayTime ? 1 : 0}`
    if (key === this._lastAvailabilityKey) return
    this._lastAvailabilityKey = key
    this.products = this.filterProducts(this.allProducts)
    this.getSections()
  }

  toggleModal = (product) => () => {
    if (product.canOrder ?? true)
      this.setState(prevState => ({
        selectedProduct: { ...product },
        showProductDetail: !prevState.showProductDetail,
        selectedIdx: undefined
      }))
  }

  closeProductModal = () => {

    this.setState({ showProductDetail: false })
  }

  getSections = () => {
    const sections = []
    for (let i = 0; i < this.categories.length; i++) {
      sections.push({
        title: this.categories[i].name,
        description: this.categories[i].description,
        data: this.products.filter((item) => item.categoryId === this.categories[i].id).sort(((a, b) => (a.index < b.index ? -1 : 1))),
        index: i,
        id: this.categories[i].id,
        category: this.categories[i]
      })
    }
    this.setState({ sections })
  }


  onClickCartProduct = (index) => e => {
    this.setState({
      selectedProduct: this.props.cart.products[index],
      showProductDetail: true,
      selectedIdx: index

    });
  };

  getOrderTotal = () => {
    let total = this.props.cart.total;
    if (this.props.cart.coupon !== null) {
      if (this.props.cart.coupon?.discountType === 'percent') {
        total = Number.parseFloat(computeDiscount(total, this.props.cart.coupon.discountPercent, true).toFixed(2));
      }
      else if (this.props.cart.coupon?.discountType === 'price') {
        total -= this.props.cart.coupon.discountPrice;
      }
    }
    return total;
  }

  closeCartModal = () => {
    this.setState({ showCart: false })
  }

  render() {
    const { t } = this.props
    const lang = this.props.settings.lang || DEFAULT_LANG
    const activeLanguages = getActiveLanguages(this.props.settings)
    if (this.state.invalidQrCode) {
      const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData404.default,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      }
      return (
        <div id="not-found">
          <Breakpoint medium up>
            <Lottie
              options={defaultOptions}
            />
          </Breakpoint>
          <Breakpoint small down>
            <Lottie
              options={defaultOptions}
            />
          </Breakpoint>
        </div>
      )
    }
    if (!this.state.informations) {
      const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData.default,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      }

      return (
        <div className="center-loading">
          <Breakpoint medium up>
            <Lottie
              options={defaultOptions}
            />
          </Breakpoint>
          <Breakpoint small down>
            <Lottie
              options={defaultOptions}
            />
          </Breakpoint>
        </div>
      )
    }

    return (
      <Container className="container" id="main-table">
        {
          this.props.settings.color && (
            <style> {`body {
              --website-color: ${this.props.settings.color}
            }`}
            </style>
          )
        }
        <div className="header">

          <div className="restaurant-info">
            <div className={`restaurant-title-row ${activeLanguages.length > 1 ? 'has-lang' : ''}`}>
              <div className="restaurant-name">
                {this.state.informations.name}
              </div>
              <LanguageSelector activeLanguages={activeLanguages} lang={lang} onChange={this.props.setLanguage} t={t} />
            </div>

            <div className="restaurant-info-table">
              <em>{t('restaurant.kioskInfo')}</em>
            </div>
          </div>
        </div>

        <div className="category-container" id="sticky-header">

          <div className="options">
            {this.categories.map((category, idx) =>
              <CategoryRow
                category={category}
                key={category.id}
                idx={idx}
                selected={idx === this.state.selectedCategoryIdx}
                selectCategory={this.selectCategory}
                lang={lang}
              />
            )}
          </div>
        </div>

        <Breakpoint medium up>
          <div className="product-grid">
            <div className="product-container">
              {this.state.sections.map((section, index) => (
                <div key={index}>
                  <Section title={getTrans(section.category, 'name', lang) || section.title} id={section.id} description={getTrans(section.category, 'description', lang)} />
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
                    {section.data.filter(p => p.displayApp).map((product) =>
                      <ProductRow
                        cartProducts={this.props.cart.products}
                        product={product}
                        key={product.id}
                        toggleModal={this.toggleModal}
                        orderType={this.props.cart.orderType}
                        settings={this.props.settings}
                        cdnDomain={this.cdnDomain}
                        lang={lang}
                        t={t}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Breakpoint>

        <Breakpoint small down>
          <div className="product-grid">
            <div className="product-container">
              {this.state.sections.map((section, index) => (
                <div className="section-container" key={index}>
                  <Section title={getTrans(section.category, 'name', lang) || section.title} id={section.id} description={getTrans(section.category, 'description', lang)} />
                  <div className="grid grid-cols-1 gap-4 p-4">
                    {section.data.filter(p => p.displayApp).map((product) =>
                      <ProductRow
                        cartProducts={this.props.cart.products}
                        product={product}
                        key={product.id}
                        toggleModal={this.toggleModal}
                        orderType={this.props.cart.orderType}
                        settings={this.props.settings}
                        cdnDomain={this.cdnDomain}
                        lang={lang}
                        t={t}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

        </Breakpoint>


        {this.readOnly === false && this.state.canOrder && this.props.cart.products.length > 0 && (
          <button className="logo logo-basket" onClick={() => this.setState({ showCart: true })}>
            <div className="footer">
              <div className="confirm-btn">
                <span>{this.props.cart.totalProducts}</span>
                <span>{t('modalCart.title')}</span>
                <span>{formatCurrency(this.props.cart.total, this.props.settings.currencySymbol)}</span>
              </div>
            </div>
          </button>
        )}

        <Modal
          show={this.state.showProductDetail}
          className="custom-map-modal"
          onHide={this.closeProductModal}
          size="md"
        >
          <ProductDetail
            cart={this.props.cart}
            product={this.state.selectedProduct}
            closeModal={this.closeProductModal}
            updateIndex={this.state.selectedIdx}
            options={this.options}
            readOnly={this.readOnly}
            canOrder={this.state.canOrder}
            cdnDomain={this.cdnDomain}
          />
        </Modal>

        <Modal
          show={this.state.showCart}
          className="custom-map-modal"
          onHide={this.closeCartModal}
          size="md"
        >
          <CartKiosk
            myCart={this.props.cart}
            cart={this.props.cart}
            closeModal={this.closeCartModal}
            options={this.options}
            readOnly={this.readOnly}
          />

        </Modal>

      </Container >
    )
  }
}

// redux

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    settings: state.settings,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRestoInfo: (a, b, c, d, e, f) => dispatch(updateRestoInfo(a, b, c, d, e, f)),
    updateRestoSettings: (a, b, c, d, e, f, g, h, i, j) => dispatch(updateRestoSettings(a, b, c, d, e, f, g, h, i, j)),
    updateMenuSettings: (s) => dispatch(updateMenuSettings(s)),
    updateType: (type) => dispatch(updateType(type)),
    applyDiscount: (d) => dispatch(applyDiscount(d)),
    updateOrderSchedule: (schedule) => dispatch(updateOrderSchedule(schedule)),
    updateDeliverySchedule: (schedule) => dispatch(updateDeliverySchedule(schedule)),
    updateDeliverySettings: (s) => dispatch(updateDeliverySettings(s)),
    updateTakeawaySettings: (s) => dispatch(updateTakeawaySettings(s)),
    resetCart: () => dispatch(resetCart()),
    applyCoupon: (coupon) => dispatch(applyCoupon(coupon)),
    pickedOrderType: () => dispatch(pickedOrderType()),
    updateTable: (table) => dispatch(updateTable(table)),
    updateQrId: (qrId) => dispatch(updateQrId(qrId)),
    setLanguage: (lang) => dispatch(setLanguage(lang)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(RestaurantKiosk));
